import { Grid, Button, Paper, Autocomplete, TextField } from "@mui/material";
import { observer } from "mobx-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import React from "react";

const createStockReceivingAdd = () => {
  return observer(() => {
    // mockup data
    const mock = [
      { key: "1", value: "a" },
      { key: "2", value: "b" },
      { key: "3", value: "c" },
      { key: "4", value: "d" },
      { key: "5", value: "e" },
    ];

    // Custom style của form tìm kiếm
    const Style = {
      ".MuiOutlinedInput-root": {
        padding: 0,
      },
      "MuiInputBase-multiline": {
        padding: 0,
      },
      "MuiInputBase-root": {
        padding: 0,
      },
      "MuiTextField-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-input": {
        fontSize: "13px",
      },
      "MuiInputBase-root-MuiOutlinedInput-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
    };
    return (
      <>
        <Grid
          container
          justifyContent={"space-between"}
          direction={"row"}
          alignItems={"center"}
          className="px-4 py-2"
        >
          <Grid item>
            <h1 className="inline-block uppercase font-semibold">
              Thêm mới phiếu nhập kho
            </h1>
            <div className="inline-block mx-2 text-blue-600 h cursor-pointer">
              <ArrowBackIcon className="!text-sm !mr-2 " />
              Quay lại
            </div>
          </Grid>
          <Grid item className="bg-blue-700 rounded">
            <Button className="!text-white hover:!opacity-80">
              <SaveIcon className="mx-2" />
              Lưu
            </Button>
          </Grid>
        </Grid>
        <Paper className="mt-1 mx-4">
          <Grid container justifyContent={"space-around"} direction={"row"}>
            {/* Left */}
            <Grid item container lg={3.5}>
              <Grid item>
                <label htmlFor="company" className="mr-1 text-sm font-bold">
                  Công Ty
                </label>
              </Grid>
              <Grid item flex={1}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mock}
                  sx={Style}
                  getOptionLabel={(option) => option.value}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Grid>
            </Grid>
            {/* Right */}
            <Grid item lg={3.5}>
              <Grid item container>
                <label htmlFor="whoRequest">Người yêu cầu</label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mock}
                  sx={Style}
                  getOptionLabel={(option) => option.value}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  });
};

export default createStockReceivingAdd;
